(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    class AvailabilitySortController {
      constructor(root) {
        this.root = root;
        this.status = root.querySelector('[data-availability-sort-status]');
        this.pageCache = new Map();
        this.generation = 0;
        this.abortController = null;
        document.addEventListener('click', (event) => this.handleToggle(event));
        document.addEventListener('headhunter:collection-rendered', () => this.refresh());
        this.refresh();
      }

      isEnabled() {
        return new URLSearchParams(window.location.search).get('availability_first') !== '0';
      }

      syncControls(enabled = this.isEnabled()) {
        document.querySelectorAll('[data-availability-sort-toggle]').forEach((control) => {
          control.hidden = false;
          control.setAttribute('aria-pressed', String(enabled));
        });
      }

      handleToggle(event) {
        const control = event.target.closest('[data-availability-sort-toggle]');
        if (!control) return;

        const params = new URLSearchParams(window.location.search);
        const grid = document.getElementById('product-grid');
        const pageParam = grid?.dataset.availabilityPageParam || 'page';
        const willEnable = !this.isEnabled();

        if (willEnable) {
          params.delete('availability_first');
        } else {
          params.set('availability_first', '0');
        }

        params.delete(pageParam);
        this.syncControls(willEnable);

        if (typeof FacetFiltersForm !== 'undefined') {
          FacetFiltersForm.renderPage(params.toString(), null);
        } else {
          const query = params.toString();
          window.location.assign(`${window.location.pathname}${query ? `?${query}` : ''}`);
        }
      }

      getGrid() {
        const grid = document.getElementById('product-grid');
        return grid?.matches('ul') ? grid : null;
      }

      getBaseKey(pageParam) {
        const params = new URLSearchParams(window.location.search);
        params.delete('availability_first');
        params.delete('section_id');
        params.delete(pageParam);
        return `${window.location.pathname}?${params.toString()}`;
      }

      readItems(grid) {
        return Array.from(grid.children)
          .filter((item) => item.matches('.grid__item[data-product-available]'))
          .map((item) => {
            const clone = item.cloneNode(true);
            clone.querySelectorAll('link[rel="stylesheet"]').forEach((link) => link.remove());
            return {
              available: item.dataset.productAvailable === 'true',
              html: clone.outerHTML,
            };
          });
      }

      ensureCardStyles(grid) {
        grid.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
          const href = link.getAttribute('href');
          const exists = Array.from(document.head.querySelectorAll('link[data-availability-card-style]')).some(
            (style) => style.getAttribute('href') === href,
          );
          if (!href || exists) return;
          const clone = link.cloneNode(true);
          clone.setAttribute('data-availability-card-style', '');
          document.head.appendChild(clone);
        });
      }

      async getPageItems(page, currentPage, currentItems, pageParam, sectionId, baseKey, signal) {
        const cacheKey = `${baseKey}|${page}`;
        if (this.pageCache.has(cacheKey)) return this.pageCache.get(cacheKey);

        let items;
        if (page === currentPage) {
          items = currentItems;
        } else {
          const url = new URL(window.location.href);
          url.searchParams.delete('availability_first');
          url.searchParams.set('section_id', sectionId);
          url.searchParams.set(pageParam, String(page));
          const response = await fetch(url.toString(), { signal });
          if (!response.ok) throw new Error(String(response.status));
          const html = await response.text();
          const parsedGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
          if (!parsedGrid?.matches('ul')) throw new Error('product-grid');
          items = this.readItems(parsedGrid);
        }

        this.pageCache.set(cacheKey, items);
        return items;
      }

      setLoading(grid, loading) {
        const collection = grid.closest('.collection');
        collection?.classList.toggle('loading', loading);
        collection?.classList.toggle('availability-sorting', loading);

        if (loading) {
          grid.style.minHeight = `${grid.getBoundingClientRect().height}px`;
        } else {
          grid.style.removeProperty('min-height');
        }

        grid.setAttribute('aria-busy', String(loading));
      }

      updateStatus(message) {
        if (this.status) this.status.textContent = message;
      }

      syncPaginationLinks(enabled, pageParam) {
        document.querySelectorAll('#ProductGridContainer .pagination-wrapper a[href]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          if (enabled) {
            url.searchParams.delete('availability_first');
          } else {
            url.searchParams.set('availability_first', '0');
          }
          if (!url.searchParams.has(pageParam)) return;
          link.href = `${url.pathname}${url.search}${url.hash}`;
        });
      }

      async refresh() {
        const enabled = this.isEnabled();
        this.syncControls(enabled);

        const grid = this.getGrid();
        if (!grid) return;

        const pageParam = grid.dataset.availabilityPageParam || 'page';
        this.syncPaginationLinks(enabled, pageParam);
        this.generation += 1;
        this.abortController?.abort();

        if (!enabled) {
          this.setLoading(grid, false);
          this.updateStatus('');
          return;
        }

        const generation = this.generation;
        const currentPage = Number(grid.dataset.availabilityCurrentPage || 1);
        const pages = Number(grid.dataset.availabilityPages || 1);
        const pageSize = Number(grid.dataset.availabilityPageSize || grid.children.length || 1);
        const sectionId = grid.dataset.id;
        const endOffset = currentPage * pageSize;
        const startOffset = endOffset - pageSize;
        const baseKey = this.getBaseKey(pageParam);
        this.ensureCardStyles(grid);
        const currentItems = this.readItems(grid);
        const collected = [];
        let loadedAllPages = false;

        this.abortController = new AbortController();
        this.setLoading(grid, true);
        this.updateStatus(this.root.dataset.availabilityLoading || '');

        try {
          for (let page = 1; page <= pages; page += 1) {
            const items = await this.getPageItems(
              page,
              currentPage,
              currentItems,
              pageParam,
              sectionId,
              baseKey,
              this.abortController.signal,
            );
            collected.push(...items);

            const availableCount = collected.reduce((count, item) => count + Number(item.available), 0);
            loadedAllPages = page === pages;
            if (availableCount >= endOffset || loadedAllPages) break;
          }

          if (generation !== this.generation) return;

          const available = collected.filter((item) => item.available);
          const ordered = loadedAllPages
            ? available.concat(collected.filter((item) => !item.available))
            : available;
          const visibleItems = ordered.slice(startOffset, endOffset);

          grid.innerHTML = visibleItems.map((item) => item.html).join('');
          grid.querySelectorAll('.scroll-trigger').forEach((item) => item.classList.add('scroll-trigger--cancel'));
          this.syncPaginationLinks(true, pageParam);
          this.updateStatus(this.root.dataset.availabilityReady || '');
        } catch (error) {
          if (error.name !== 'AbortError' && generation === this.generation) {
            this.updateStatus(this.root.dataset.availabilityError || '');
          }
        } finally {
          if (generation === this.generation) this.setLoading(grid, false);
        }
      }
    }

    const initialize = () => {
      const root = document.querySelector('[data-availability-sort-root]');
      if (!root || window.headHuntersAvailabilitySort) return;
      window.headHuntersAvailabilitySort = new AvailabilitySortController(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
